export namespace LocaleUtils {
  /**
   * Attempts to find the closest tag with a lang attribute.
   * Falls back to english if no language is found.
   * @param element The element to find a lang attribute for.
   */
  export function getLangContext(element: HTMLElement = document.body): string {
    const closestElement = element.closest('[lang]') as HTMLElement;
    return closestElement ? closestElement.lang.substring(0, 2) : 'en';
  }

  export function getTranslations(translations: any, lang: string): string {
    try {
      if (translations && translations[lang]) {
        return translations[lang];
      } else {
        return translations['en'];
      }
    } catch (error) {
      console.warn('Error getting translations', error);
    }
  }
}
